import VueFormulate from '@braid/vue-formulate'
import { FormBaseComponent } from '@internal-libraries/kheops-ui-lib'
import FormBaseComponentEmpty from './formComponent'
import ClvrScreenControlTemplateListDraggable
    from '../../modules/screenControl/vue/Components/ClvrScreenControlTemplateList/ClvrScreenControlTemplateListDraggable/ClvrScreenControlTemplateListDraggable.vue'
import ClvrScreenControlTable
    from '../../modules/screenControl/vue/Components/ClvrScreenControlPlanningTable/ClvrScreenControlTable/ClvrScreenControlTable'
import ClvrScreenControlTemplateListDataTypeHeaders
    from '../../modules/screenControl/vue/Components/ClvrScreenControlTemplateList/ClvrScreenControlTemplateListDataTypeHeaders/ClvrScreenControlTemplateListDataTypeHeaders'
import ClvrScreenControlPlanningTable from '../../modules/screenControl/vue/Components/ClvrScreenControlPlanningTable/ClvrScreenControlPlanningTable.vue'
import ClvrConfigCategory
    from "../../modules/system/vue/Components/ConfigurationManager/ClvrConfigCategory/ClvrConfigCategory.vue";
import ClvrConfig from "../../modules/system/vue/Components/ConfigurationManager/ClvrConfig/ClvrConfig.vue";
import ClvrConfigElement
    from "../../modules/system/vue/Components/ConfigurationManager/ClvrConfigElement/ClvrConfigElement.vue";
import ClvrConfigElementList
    from "../../modules/system/vue/Components/ConfigurationManager/ClvrConfigElement/ClvrConfigElementList/ClvrConfigElementList.vue";
import ClvrConfigElementObjectSelect
    from "../../modules/system/vue/Components/ConfigurationManager/ClvrConfigElement/ClvrConfigElementObjectSelect/ClvrConfigElementObjectSelect.vue";

export default function(formulateInstance: typeof VueFormulate): void {
    formulateInstance.extend({
        components: {
            FormBaseComponent,
            FormBaseComponentEmpty,
            ClvrScreenControlTemplateListDraggable,
            ClvrScreenControlPlanningTable,
            ClvrScreenControlTable,
            ClvrScreenControlTemplateListDataTypeHeaders,
            ClvrConfig,
            ClvrConfigCategory,
            ClvrConfigElement,
            ClvrConfigElementList,
            ClvrConfigElementObjectSelect
        },
        library: {
            ClvrPatientAutocomplete: {
                classification: 'select',
                component: 'FormBaseComponent'
            },
            ChainingManagementContext: {
                classification: 'text',
                component: 'FormBaseComponentEmpty'
            },
            KhCheckbox: {
                classification: 'button',
                component: 'FormBaseComponent'
            },
            ChainingManagementServiceList: {
                classification: 'text',
                component: 'FormBaseComponent'
            },
            ClvrPrscPosologyFrequencySelector: {
                classification: 'text',
                component: 'FormBaseComponent'
            },
            ClvrPrscPosologyCustomized: {
                classification: 'text',
                component: 'FormBaseComponent'
            },
            ClvrScreenControlTemplateListDraggable: {
                classification: 'list',
                component: 'FormBaseComponent'
            },
            ClvrScreenControlPlanningTable: {
                classification: 'list',
                component: 'FormBaseComponent'
            },
            ClvrScreenControlTable: {
                classification: 'table',
                component: 'FormBaseComponent'
            },
            ClvrScreenControlTemplateListDataTypeHeaders: {
                classification: 'table',
                component: 'FormBaseComponent'
            },
            ClvrConfig: {
                classification: 'table',
                component: 'FormBaseComponent'
            },
            ClvrConfigCategory: {
                classification: 'table',
                component: 'FormBaseComponent'
            },
            ClvrConfigElement: {
                classification: 'table',
                component: 'FormBaseComponent'
            },
            ClvrConfigElementList: {
                classification: 'table',
                component: 'FormBaseComponent'
            },
            ClvrConfigElementObjectSelect: {
                classification: 'table',
                component: 'FormBaseComponent'
            }
        }
    })
}
